import { render, staticRenderFns } from "./ProgramadorClase.vue?vue&type=template&id=4f6e24aa&"
import script from "./ProgramadorClase.vue?vue&type=script&lang=js&"
export * from "./ProgramadorClase.vue?vue&type=script&lang=js&"
import style0 from "./ProgramadorClase.vue?vue&type=style&index=0&id=4f6e24aa&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports